var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['listComment', _vm.listClassName]},[_c('ul',_vm._l((_vm.listdata),function(it,index){return _c('li',{key:index},[_c('img',{attrs:{"src":it.img}}),_c('div',{staticClass:"text"},[_c('h4',[_vm._v(_vm._s(it.h4))]),_c('p',[_vm._v(_vm._s(it.p))])]),_vm._t("default")],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }